import { render, staticRenderFns } from "./ModalAdd.vue?vue&type=template&id=1460b457&scoped=true"
import script from "./ModalAdd.vue?vue&type=script&lang=js"
export * from "./ModalAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalAdd.vue?vue&type=style&index=0&id=1460b457&prod&lang=scss"
import style1 from "./ModalAdd.vue?vue&type=style&index=1&id=1460b457&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460b457",
  null
  
)

export default component.exports